/**
 * Testimonial Actions
 */
import {
  FETCH_TESTIMONIAL_REQUEST,
  FETCH_TESTIMONIAL_SUCCESS,
  FETCH_TESTIMONIAL_FAILURE,
  DELETE_TESTIMONIAL_SUCCESS,
  UPDATE_TESTIMONIAL_SUCCESS,
  UPLOAD_TESTIMONIAL_AVATAR_REQUEST,
  UPLOAD_TESTIMONIAL_AVATAR_SUCCESS,
  UPLOAD_TESTIMONIAL_AVATAR_FAILURE,
} from '../constants/ActionTypes';
import TestimonialAPIConnectors from '../api/TestimonialAPIConnectors';

export function fetchTestimonialRequest() {
  return {
    type: FETCH_TESTIMONIAL_REQUEST,
  };
}

export function fetchTestimonialSuccess(data) {
  return {
    type: FETCH_TESTIMONIAL_SUCCESS,
    data,
  };
}

export function fetchTestimonialFailure() {
  return {
    type: FETCH_TESTIMONIAL_FAILURE,
  };
}

export function deleteTestimonialSuccess(id) {
  return {
    type: DELETE_TESTIMONIAL_SUCCESS,
    id,
  };
}

export function updateTestimonialSuccess(id, testimonial) {
  return {
    type: UPDATE_TESTIMONIAL_SUCCESS,
    id,
    testimonial,
  };
}

export function uploadTestimonialAvatarRequest() {
  return {
    type: UPLOAD_TESTIMONIAL_AVATAR_REQUEST,
  };
}

export function uploadTestimonialAvatarSuccess(id, avatar) {
  return {
    type: UPLOAD_TESTIMONIAL_AVATAR_SUCCESS,
    id,
    avatar,
  };
}

export function uploadTestimonialAvatarFailure() {
  return {
    type: UPLOAD_TESTIMONIAL_AVATAR_FAILURE,
  };
}

export function uploadTestimonialAvatar(testimonial, formData) {
  return async (dispatch) => {
    dispatch(uploadTestimonialAvatarRequest());

    try {
      const avatar = await TestimonialAPIConnectors.uploadAvatar(testimonial.userId, formData);
      dispatch(uploadTestimonialAvatarSuccess(testimonial.id, avatar));
    } catch (err) {
      dispatch(uploadTestimonialAvatarFailure());
      throw err;
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/TestimonialActionCreators.js